const layouts = new WeakMap();
const selector = '[data-header-layout]';
const properties = {
    sticky: '--z-sticky-header-height',
    flow: '--z-site-header-flow-height',
};

/** Subscribe only the element that actually consumes measured header sizes. */
export function registerHeaderLayout(element, dimensions = 'sticky') {
    element.setAttribute('data-header-layout', dimensions);
    layouts.get(element.ownerDocument)?.register(element);
}

export function initHeaderLayout(header) {
    const document = header.ownerDocument;
    const existing = layouts.get(document);
    if (existing) return existing.publish;
    const consumers = new Set();
    let sizes;

    function apply(element) {
        if (!sizes) return;
        const dimensions = (element.dataset.headerLayout || '').split(/\s+/u);
        for (const [dimension, property] of Object.entries(properties)) {
            if (!dimensions.includes(dimension)) continue;
            const value = `${sizes[dimension]}px`;
            if (element.style.getPropertyValue(property) !== value) {
                element.style.setProperty(property, value);
            }
        }
    }

    function register(element) {
        consumers.add(element);
        apply(element);
    }

    function scan(root) {
        if (root.matches?.(selector)) register(root);
        root.querySelectorAll?.(selector).forEach(register);
    }

    function publish(nextSizes) {
        sizes = nextSizes;
        consumers.forEach((element) => {
            if (!element.isConnected) consumers.delete(element);
            else apply(element);
        });
    }

    layouts.set(document, { register, publish });
    scan(document);
    document.addEventListener('zirbelino:content-updated', (event) => {
        if (event.detail?.root?.ownerDocument === document) scan(event.detail.root);
    });
    return publish;
}
